import {
  useMutation,
  UseMutationOptions,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';
import { ValidateAudienceData } from '../../endpoints/audiences';

export interface ValidateAudienceParams {
  data: ValidateAudienceData;
  group: string;
}

export const validateAudience = async (params: ValidateAudienceParams): Promise<void> => {
  return await tinctApi.audiences.validateAudience(params.data, params.group);
};

export const useValidateAudience = (
  options?: Omit<
    UseMutationOptions<void, ApiError, ValidateAudienceParams>,
    'mutationFn'
  >,
) => {
  return useMutation({
    mutationFn: validateAudience,
    ...options,
  });
};